(function () {
  const html = document.documentElement;
  const selectors = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), details, [tabindex]:not([tabindex="-1"])';
  const mobileQuery = window.matchMedia('(max-width: 759px)');
  let previousFocus = null;
  let cartDrawerPlaceholder = null;

  function drawer() {
    return document.querySelector('[data-cryela-drawer]');
  }

  function setPageInert(active) {
    const drawerEl = drawer();
    const keep = new Set([drawerEl, document.querySelector('[data-cryela-backdrop]')]);
    Array.from(document.body.children).forEach((child) => {
      if (keep.has(child) || child.contains(drawerEl)) return;
      if (active) {
        child.setAttribute('inert', '');
      } else {
        child.removeAttribute('inert');
      }
    });
  }

  function focusFirst() {
    const drawerEl = drawer();
    const focusable = drawerEl ? Array.from(drawerEl.querySelectorAll(selectors)).filter((el) => el.offsetParent !== null) : [];
    (focusable[0] || drawerEl)?.focus({ preventScroll: true });
  }

  function openDrawer() {
    const drawerEl = drawer();
    if (!drawerEl) return;
    previousFocus = document.activeElement;
    html.classList.add('cryela-drawer-open');
    drawerEl.removeAttribute('aria-hidden');
    setPageInert(true);
    window.setTimeout(focusFirst, 30);
  }

  function closeDrawer() {
    const drawerEl = drawer();
    html.classList.remove('cryela-drawer-open');
    if (drawerEl) drawerEl.setAttribute('aria-hidden', 'true');
    setPageInert(false);
    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus({ preventScroll: true });
    }
  }

  function trapFocus(event) {
    if (event.key !== 'Tab' || !html.classList.contains('cryela-drawer-open')) return;
    const drawerEl = drawer();
    if (!drawerEl) return;
    const focusable = Array.from(drawerEl.querySelectorAll(selectors)).filter((el) => el.offsetParent !== null);
    if (!focusable.length) {
      event.preventDefault();
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openSearch() {
    const searchModal = document.querySelector('#search-modal');
    if (searchModal && typeof searchModal.showDialog === 'function') {
      searchModal.showDialog();
      return;
    }
    const trigger = document.querySelector('search-button button, button[on\\:click="#search-modal/showDialog"]');
    if (trigger) {
      trigger.click();
      return;
    }
    window.location.href = '/search';
  }

  function findCartDrawer() {
    const drawerSelectors = [
      'cart-drawer-component',
      'cart-drawer',
      '#CartDrawer',
      '#cart-drawer',
      '[data-cart-drawer]',
      'cart-notification',
      '#cart-notification',
      '.cart-drawer',
      'details[id*="cart" i]',
      '#cart-modal',
      '[id*="MiniCart" i]'
    ];
    for (const selector of drawerSelectors) {
      const drawerEl = document.querySelector(selector);
      if (drawerEl) return drawerEl;
    }
    return null;
  }

  function ensureCartDrawerAvailable() {
    const cartDrawer = findCartDrawer();
    if (!cartDrawer) return null;

    if (mobileQuery.matches && cartDrawer.closest('#header-component')) {
      cartDrawerPlaceholder = cartDrawerPlaceholder || document.createComment('cryela cart drawer placeholder');
      cartDrawer.parentNode.insertBefore(cartDrawerPlaceholder, cartDrawer);
      document.body.appendChild(cartDrawer);
    } else if (!mobileQuery.matches && cartDrawerPlaceholder?.parentNode && cartDrawer.parentNode === document.body) {
      cartDrawerPlaceholder.parentNode.insertBefore(cartDrawer, cartDrawerPlaceholder);
      cartDrawerPlaceholder.remove();
      cartDrawerPlaceholder = null;
    }

    return cartDrawer;
  }

  function openCart(event) {
    const cartDrawer = ensureCartDrawerAvailable();
    if (!cartDrawer) {
      console.log('[CryelaNav] No cart drawer found, navigating to /cart');
      return;
    }

    event.preventDefault();

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else if (typeof cartDrawer.show === 'function') {
      cartDrawer.show();
    } else if (cartDrawer.tagName === 'DETAILS') {
      cartDrawer.setAttribute('open', '');
    } else {
      const trigger = cartDrawer.querySelector('[data-testid="cart-drawer-trigger"], button[aria-haspopup="dialog"]');
      if (trigger) {
        trigger.click();
      } else {
        cartDrawer.classList.add('active', 'is-open', 'open');
      }
    }

    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
  }

  function updateCartBadge(count) {
    const parsed = Number(count);
    if (!Number.isFinite(parsed)) return;
    document.querySelectorAll('[data-cart-count], [data-cryela-cart-badge]').forEach((badge) => {
      badge.textContent = String(parsed);
      badge.hidden = parsed <= 0;
      badge.classList.remove('is-bumping');
      void badge.offsetWidth;
      if (parsed > 0) badge.classList.add('is-bumping');
    });
    document.querySelectorAll('cart-icon').forEach((cartIcon) => {
      if ('cartCount' in cartIcon) cartIcon.cartCount = parsed;
    });
  }

  function visibleCartCount(cart) {
    if (!cart?.items) return cart?.item_count;
    return cart.items.reduce((count, item) => {
      const isExtraPhoto =
        Number(item.variant_id) === 57427065602379 ||
        item.properties?._cryela_locked === 'true' ||
        item.properties?.Motivo === 'Foto extra personalizzazione';
      return count - (isExtraPhoto ? Number(item.quantity || 0) : 0);
    }, Number(cart.item_count || 0));
  }

  function cartCountFromEvent(event) {
    const detail = event.detail || {};
    if (detail.resource?.items) return visibleCartCount(detail.resource);
    if (detail.cart?.items) return visibleCartCount(detail.cart);
    return detail.data?.displayItemCount ?? detail.displayItemCount ?? detail.item_count ?? detail.data?.itemCount ?? detail.data?.item_count;
  }

  async function refreshCart() {
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) return;
      const cart = await response.json();
      updateCartBadge(visibleCartCount(cart));
    } catch (error) {
      console.warn('[CryelaNav] cart refresh failed', error);
    }
  }

  function fetchCartCount() {
    refreshCart();
  }

  function setupCartButton() {
    ensureCartDrawerAvailable();
    document.querySelectorAll('[data-bottom-nav-cart]').forEach((cartButton) => {
      if (cartButton.dataset.cryelaCartReady === 'true') return;
      cartButton.dataset.cryelaCartReady = 'true';
      cartButton.addEventListener('click', openCart);
    });
  }

  function patchFetch() {
    if (!window.fetch || window.fetch.__cryelaPatched) return;
    const originalFetch = window.fetch;
    function cryelaFetch() {
      const args = arguments;
      const result = originalFetch.apply(this, args);
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        result.then(() => window.setTimeout(refreshCart, 100)).catch(() => {});
      }
      return result;
    }
    cryelaFetch.__cryelaPatched = true;
    window.fetch = cryelaFetch;
  }

  function initAnnouncementRotation() {
    document.querySelectorAll('[data-cryela-announcement]').forEach((bar) => {
      const items = Array.from(bar.querySelectorAll('[data-cryela-announcement-message]'));
      if (items.length < 2 || bar.dataset.cryelaReady === 'true') return;
      bar.dataset.cryelaReady = 'true';
      let index = 0;
      let paused = false;
      const speed = Math.max(2, Number(bar.dataset.rotationSpeed || 4)) * 1000;
      items.forEach((item, itemIndex) => {
        item.hidden = itemIndex !== 0;
        item.style.opacity = itemIndex === 0 ? '1' : '0';
      });
      function show(next) {
        items[index].style.opacity = '0';
        window.setTimeout(() => {
          items[index].hidden = true;
          index = next;
          items[index].hidden = false;
          window.requestAnimationFrame(() => {
            items[index].style.opacity = '1';
          });
        }, 300);
      }
      const timer = window.setInterval(() => {
        if (!paused) show((index + 1) % items.length);
      }, speed);
      bar.addEventListener('touchstart', () => { paused = true; }, { passive: true });
      bar.addEventListener('mouseenter', () => { paused = true; });
      bar.addEventListener('mouseleave', () => { paused = false; });
      bar.addEventListener('shopify:section:unload', () => window.clearInterval(timer));
    });
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cryela-drawer-open]')) openDrawer();
    if (event.target.closest('[data-cryela-drawer-close], [data-cryela-backdrop]')) closeDrawer();
    if (event.target.closest('[data-cryela-search]')) openSearch();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && html.classList.contains('cryela-drawer-open')) closeDrawer();
    trapFocus(event);
  });

  ['cart:update', 'cart:updated', 'cart:refresh', 'cart:change', 'cart-updated', 'cartUpdated'].forEach((name) => {
    document.addEventListener(name, (event) => {
      const count = cartCountFromEvent(event);
      if (count === undefined) {
        refreshCart();
      } else {
        updateCartBadge(count);
      }
    });
    window.addEventListener(name, refreshCart);
  });

  patchFetch();
  if (window.subscribe && window.PUB_SUB_EVENTS?.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refreshCart);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAnnouncementRotation();
    setupCartButton();
    refreshCart();
  });
  document.addEventListener('shopify:section:load', () => {
    initAnnouncementRotation();
    setupCartButton();
  });

  mobileQuery.addEventListener?.('change', ensureCartDrawerAvailable);
})();
